<template>
  <fragment>
    <v-container class="my-5">
      <v-row class="my-10" justify="center">
        <v-col cols="10">
          <div v-html="$t('promoSzoveg')" class="text-center"></div>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid class="px-0 animation-stepper-wrapper-container">
      <v-img :src="require('../assets/samsung/steps-bg.png')" cover position="top center" class="animation-stepper-wrapper-outer">
        <v-container class="fill-height">
          <v-row class="fill-height" align="end" justify="center">
            <v-col cols="12" class="animation-stepper-wrapper">
              <v-card>
                <v-progress-linear v-model="progressValue"
                                   :color="VStepper === VStepperHeader.length ? 'success': 'primary'"
                                   height="4">
                </v-progress-linear>
                <v-stepper v-model="VStepper" alt-labels>
                  <v-stepper-header>
                    <template v-for="(item, index) in VStepperHeader">
                      <v-stepper-step :key="index"
                                      :step="item.step"
                                      :color="index === VStepperHeader.length-1 ? 'success': 'primary'"
                                      :complete="VStepper > index+1">
                        <span :class="index === VStepperHeader.length-1 ? 'success--text': ''">
                          <b>{{ $t(`${item.title}`) }}</b>
                        </span>
                      </v-stepper-step>
                      <v-divider v-if="index !== VStepperHeader.length-1"></v-divider>
                    </template>
                  </v-stepper-header>
                </v-stepper>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-img>
    </v-container>
    <v-container class="my-5">
      <v-row class="my-10" justify="center">
        <v-col cols="10">
          <div v-html="$t('sellYourDeviceWithTmxBBSzoveg')" class="text-center"></div>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid class="oval-bg">
      <v-container class="my-10">
        <v-row class="my-10 py-10">
          <v-col cols="12" sm="4" v-for="(item, index) in infos" :key="index">
            <div class="display-1 text-center" style="height: 82px;">
              {{ $t(item.title) }}
            </div>
            <div class="mt-5 text-center" v-html="$t(item.desc)"></div>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <v-container class="my-5" id="szallitas">
      <v-row class="my-10" justify="center">
        <v-col cols="10">
          <div class="display-2 text-center mb-8">
            <b>A szállításhoz szükséges információk</b>
          </div>
        </v-col>
        <v-col cols="6" sm="4" v-for="(item, index) in shippingInfos" :key="index" class="mb-5">
          <div class="headline text-center mb-4 font-weight-bold">
            {{ index+1 }}.
          </div>
          <div class="text-center">
            {{ item }}
          </div>
        </v-col>
      </v-row>
    </v-container>
  </fragment>
</template>

<script>
import fancyHeadline from "../components/fancyHeadline.vue";

export default {
  name: 'GeneralInformationsPage',
  components: {
    fancyHeadline,
  },
  props: {
    //
  },
  mounted() {
    setInterval(this.stepAnimation, 2200);
  },
  data() {
    return {
      VStepper: 1,
      VStepperHeader: [
        { step: 1, title: 'stepper.calculate', isDivider: false },
        { step: 2, title: 'stepper.sendYourDevice', isDivider: false },
        { step: 3, title: 'stepper.examFree', isDivider: false },
        { step: 4, title: 'stepper.acceptOffer', isDivider: false },
        { step: 5, title: 'stepper.transferMoney', isDivider: false },
      ],
      progressValue: 20,
      infos: [
        {
          title: 'information.first.title',
          desc: 'information.first.desc',
        },
        {
          title: 'information.second.title',
          desc: 'information.second.desc',
        },
        {
          title: 'information.third.title',
          desc: 'information.third.desc',
        }
      ],
      shippingInfos: [
        'Távolítsd el a szállítóládát lezáró plombát és nyitást követően a következőket találod a szállítóládában (2 db vízhatlan zacskó, 2 db plomba, 1 db visszaszállítási címirat, öntapadó fóliatasak)',
        'Vedd ki mindet a szállítóládából',
        'Helyezd a készüléked a vízhatlan zacskóba, a másik vízhatlan zacskóba pedig, az eladáshoz szükséges tartozékokat (akkumulátor, töltő).',
        'Ezt követően zárd le a 2 db vízhatlan zacskót és tedd bele a szállítóládába!',
        'A 2 db plomba segítségével - a kézbesítő jelenlétében zárd le a ládát!',
        'A visszaszállítási címirat ügyfélpéldányát a kézbesítő aláírja, azt őrizd meg, ez igazolja a csomag visszaküldését!',
        'A visszaszállítási címirat postai példányát helyezd az öntapadós fóliatasakba és ragaszd a szállítóláda tetejére.',
      ]
    };
  },
  methods: {
    stepAnimation() {
      if (this.VStepper === 5) {
        this.VStepper = 1;
        this.progressValue = 20;
      } else {
        this.VStepper += 1;
        this.progressValue += 20;
      }
    }
  },
};
</script>

<style scoped>

</style>
